"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = exports.TestRadio = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _propValidators = require("../utils/propValidators");

var _forwardRef = _interopRequireDefault(require("../utils/forwardRef"));

var _HelperText = _interopRequireDefault(require("../HelperText"));

var _RadioGroup = _interopRequireDefault(require("./RadioGroup"));

var _withId = _interopRequireDefault(require("../utils/withId"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes = {
  checked: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  compact: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  error: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].bool]),
  forwardedRef: _propTypes["default"].exact({
    current: typeof HTMLInputElement !== 'undefined' ? _propTypes["default"].instanceOf(HTMLInputElement) : _propTypes["default"].elementType
  }),
  helper: _propTypes["default"].node,
  hideLabel: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  label: _propValidators.accessibleLabelType.isRequired,
  labelId: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var defaultProps = {
  compact: false,
  checked: false,
  disabled: false,
  error: false,
  hideLabel: false,
  onChange: function onChange() {},
  onSelect: function onSelect() {},
  value: ''
};

var Radio = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Radio, _Component);

  function Radio() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleKeyPress = function (event) {
      if (event.key === 'Enter') {
        _this.handleSelect();
      }
    };

    _this.handleSelect = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          value = _this$props.value,
          onSelect = _this$props.onSelect;

      if (!disabled) {
        onSelect(value);
      }
    };

    return _this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        label = _this$props2.label,
        value = _this$props2.value,
        checked = _this$props2.checked,
        disabled = _this$props2.disabled,
        id = _this$props2.id,
        error = _this$props2.error,
        helper = _this$props2.helper,
        className = _this$props2.className,
        compact = _this$props2.compact,
        labelId = _this$props2.labelId,
        onChange = _this$props2.onChange,
        onSelect = _this$props2.onSelect,
        hideLabel = _this$props2.hideLabel,
        forwardedRef = _this$props2.forwardedRef,
        otherProps = _objectWithoutPropertiesLoose(_this$props2, ["label", "value", "checked", "disabled", "id", "error", "helper", "className", "compact", "labelId", "onChange", "onSelect", "hideLabel", "forwardedRef"]);

    var classes = (0, _classnames["default"])('grv-radiobutton', className, {
      'grv-radiobutton--error': error,
      'grv-radiobutton--compact': compact
    });
    var labelClasses = (0, _classnames["default"])('grv-label', 'grv-label--radiobutton', {
      'grv-label--compact': compact,
      'grv-label--disabled': disabled,
      'grv-visually-hidden': hideLabel
    });
    var wrapperClasses = (0, _classnames["default"])('grv-form-field', {
      'grv-form-field--compact': compact
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: wrapperClasses
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "grv-radiobutton__wrapper",
      htmlFor: id,
      id: labelId
    }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, otherProps, {
      checked: checked,
      className: classes,
      disabled: disabled,
      id: id,
      onChange: onChange,
      onClick: this.handleSelect,
      onKeyPress: this.handleKeyPress,
      ref: forwardedRef,
      type: "radio",
      value: value
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: labelClasses
    }, label)), /*#__PURE__*/_react["default"].createElement(_HelperText["default"], {
      error: true,
      content: error,
      type: "radiobutton"
    }), /*#__PURE__*/_react["default"].createElement(_HelperText["default"], {
      content: helper,
      type: "radiobutton"
    }));
  };

  return Radio;
}(_react.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
Radio.Group = _RadioGroup["default"];
var TestRadio = Radio;
exports.TestRadio = TestRadio;

var _default = (0, _forwardRef["default"])((0, _withId["default"])(Radio));

exports["default"] = _default;